/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Reports_HeadingInputs */

const ja_playdata_home_reports_heading = /** @type {(inputs: Playdata_Home_Reports_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAレポートで、eスポーツと配信の分析を簡単に`)
};

const en_playdata_home_reports_heading = /** @type {(inputs: Playdata_Home_Reports_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA Reports make esports and streaming analysis easy`)
};

/**
* | output |
* | --- |
* | "PLAYDATA Reports make esports and streaming analysis easy" |
*
* @param {Playdata_Home_Reports_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_reports_heading = /** @type {((inputs?: Playdata_Home_Reports_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Reports_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_reports_heading(inputs)
	return en_playdata_home_reports_heading(inputs)
});